// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import KeldanAppDisclaimerPage from '../../components/KeldanAppDisclaimerPage/KeldanAppDisclaimerPage';

const Disclaimer: React.FC = () => {
    return (
        <Entrypoint>
            <KeldanAppDisclaimerPage />
        </Entrypoint>
    );
}

export default Disclaimer;